export function setNotifications (state, notifications) {
  state.notifications = notifications
}

export function addNotifications (state, notifications) {
  state.notifications.notifications.push(...notifications.notifications)
  state.notifications.self = notifications.self
  state.notifications.next = notifications.next
}

export function addNotification (state, notification) {
  if (!state.notifications) {
    state.notifications = { notifications: [] }
  }

  state.notifications.notifications.unshift(notification)
  state.notificationAdded = notification
}

export function cleanNotificationAdded (state) {
  state.notificationAdded = null
}
